import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["serialSpan"];

  connect() {
    this.pollCartForSerialNumber();
  }

  async pollCartForSerialNumber() {
    let pollAttempts = 0;
    let checkForSerialNumber = async function() {
      if (++pollAttempts > 30) {
        this.showError();
        return;
      }
      let response = await fetch(
        `${window.location.pathname}/purchases/${this.data.get("purchase-number")}`
      );
      if (response.status != 200) {
        this.showError();
        return;
      }
      let result = await response.json();
      if (!result.serial_number) {
        setTimeout(checkForSerialNumber, 1000);
      } else {
        this.serialSpanTarget.innerText = result.serial_number;
      }
    }.bind(this);
    await checkForSerialNumber();
  }

  showError() {
    this.serialSpanTarget.innerHTML = this.data.get('generic-stripe-error');
    $(this.serialSpanTarget).removeClass("text-xl font-bold");
    $(this.serialSpanTarget).addClass("text-xs text-phorest-red-dark bg-phorest-red-light rounded p-2");
  }
}
